import {
  NotificationModuleLocation as NotificationModuleLocationBase,
} from '@domain-group/suit-theme'

import { useNotificationBanner } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useNotifications from '@hooks/useNotifications'

import locationOptions from '@functions/notification'
import { digObject } from '@domain-group/javascript-utils'

type NotificationModuleLocationProps = {
  boxProps?: object,
  locationKey: string,
}

const NotificationModuleLocation = (props: NotificationModuleLocationProps) => {
  const { locationKey, boxProps = {} } = props

  const { currentUser: { id: userId } } = useCurrentUser()

  const { filteredNotifications } = useNotifications({
    filters: {
      active: 'true',
      location: 'targeted',
      realhub_platform: 'standalone_v1',
      targetLocation: locationKey,
    },
    performHttpRequests: !!locationKey,
    requestOptions: {
      include_notification_image: true,
      include_attachment_file: true,
      limit: locationOptions.length,
    },
  })

  const lastIndex = filteredNotifications.length ? filteredNotifications.length - 1 : 0
  const notification = filteredNotifications[lastIndex] || {}

  // @ts-expect-error TS2322
  const useNotificationBannerPayload = useNotificationBanner({ userId, notification })
  const {
    callbacks: { dismissNotification },
    isDismissed,
    seenNotifications,
  } = useNotificationBannerPayload

  const dismissable = digObject(notification, 'options.dismissable')
  const isDismissable = !!dismissable

  if (!notification.id || seenNotifications.includes(notification.id) || isDismissed){
    return null
  }

  return (
    <NotificationModuleLocationBase
      boxProps={boxProps}
      callbacks={{ dismissNotification }}
      isDismissable={isDismissable}
      notification={notification}
      target="_blank"
    />
  )
}

export default NotificationModuleLocation
